import React from 'react';
import PropTypes from 'prop-types';
import Defrost from '../assets/components/Defrost';
import Light from '../assets/components/Light';
import SaveEnergyDay from '../assets/components/Day';
import SaveEnergyNight from '../assets/components/Night';
import SetPointS1 from '../assets/components/SetPointS1';
import SetPointS2 from '../assets/components/SetPointS2';
import TurnOnOff from '../assets/components/TurnOnOff';
import GlassHeater from '../assets/components/GlassHeater';
import KnifeWiper from '../assets/components/KnifeWiper';
import Flashfreeze from '../assets/components/Flashfreeze';
import Flashcool from '../assets/components/Flashcool';
import DoorHeater from '../assets/components/DoorHeater';
import SuperFrost from '../assets/components/SuperFrost';
import Humidity from '../assets/components/Humidity';
import Status from '../status';
import SetPointP1 from '../assets/components/P1';
import SetPointP2 from '../assets/components/P2';
import SetPointT from '../assets/components/SetPointT';
import SetPointH from '../assets/components/SetPointH';
import Cycle from '../assets/components/Cycle';
import Direct from '../assets/components/Direct';
import {
  SIZE_BIG,
  SIZE_MEDIUM,
  SIZE_SMALL,
  TYPE_DEFROST,
  TYPE_LIGHT,
  TYPE_SAVE_ENERGY,
  TYPE_SETPOINT,
  TYPE_TURN_ON_OFF,
  TYPE_GLASS_HEATER,
  TYPE_KNIFE_WIPER,
  TYPE_DOOR_HEATER,
  TYPE_SUPERFROST,
  TYPE_HUMIDITY,
  TYPE_FLASHFREEZE,
  TYPE_FLASHCOOL,
  TYPE_SETPOINT_P1,
  TYPE_SETPOINT_P2,
  TYPE_SETPOINT_T,
  TYPE_SETPOINT_H,
  TYPE_DIRECT,
  TYPE_CYCLE,
} from '../constants';
import { colorsModeUI } from '../modeUI';
import './index.css';

export const LABEL_MAX_LENGHT_SIZE_BIG = 10;
export const LABEL_MAX_LENGHT_SIZE_MEDIUM = 9;
export const LABEL_MAX_LENGHT_SIZE_SMALL = 8;

/**
 * Actions buttons
 * display a button of the type  DEFROST, LIGHT, SAVE_ENERGY, SET_POINT, TURN_ON_OFF,
 * GLASS_HEATER, KNIFE_WIPER, DOOR_HEATER, SUPERFROST, HUMIDITY, FLASHFREEZE and FLASHCOOL
 * Parameters (Props):
 * @param bool active
 * @param bool disable: by disable = true => then the event onClick will be not called
 * @param string tooltip
 * @param string label
 * @param func onClick
 * @param string size: [small, medium, big]
 * @param string type: [TYPE_DEFROST, TYPE_LIGHT, TYPE_SAVE_ENERGY,
 *                     TYPE_SETPOINT, TYPE_TURN_ON_OFF]
 * @param string mode: [MODE_DARK, MODE_LIGHT]
 * @param number setpoint: used only by the type = SET_POINT
 */
export default class ActionButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHover = this.toggleHover.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * Toggle hover
   */
  toggleHover() {
    const { hover } = this.state;
    this.setState({ hover: !hover });
  }

  render() {
    let {
      active,
      disable,
      tooltip,
      onClick,
      size,
      type,
      mode,
      setpoint,
      loading,
    } = this.props;
    if (loading) {
      disable = true;
    }

    let { label } = this.props;
    const { hover } = this.state;
    const colors = colorsModeUI(mode);
    /* style button container and image */
    const styleBox = { textAlign: 'center' };
    styleBox.backgroundColor = active
      ? colors.ACTION_BUTTON_BACKGROUND_ACTIVE_COLOR
      : colors.ACTION_BUTTON_BACKGROUND_INACTIVE_COLOR;

    const styleImage = {};
    if (disable) {
      styleImage.color = colors.ACTION_BUTTON_CONSTRAST_TEXT_DISABLE_COLOR;
      styleImage.fill = colors.ACTION_BUTTON_CONSTRAST_TEXT_DISABLE_COLOR;
      styleBox.color = colors.ACTION_BUTTON_CONSTRAST_TEXT_DISABLE_COLOR;
      styleBox.backgroundColor = colors.ACTION_BUTTON_BACKGROUND_INACTIVE_COLOR;
    }

    if (!disable) {
      if (hover && onClick) {
        styleBox.boxShadow = colors.ACTION_BUTTON_SHADOW_HOVER;
      }
    }
    let imageSVG;
    let SaveEnergy = SaveEnergyDay;
    let SetPoint = SetPointS1;
    /* Class name svg image */
    const classNameImage = ['action-button'];
    if (!disable && onClick) {
      classNameImage.push('button');
    }
    classNameImage.push('image');
    classNameImage.push(size);

    switch (type) {
      case TYPE_DEFROST:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <Defrost
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="defrost"
          />
        );
        break;
      case TYPE_LIGHT:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_LIGHT_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_LIGHT_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <Light
            className={`${classNameImage.join(' ')}`}
            style={{ ...styleImage, ...(disable ? { transform: 'none' } : {}) }}
            id="light"
          />
        );
        break;
      case TYPE_SAVE_ENERGY:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_SAVE_ENERGY_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_SAVE_ENERGY_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          SaveEnergy = active ? SaveEnergyNight : SaveEnergyDay;
        }
        imageSVG = (
          <SaveEnergy
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="saveEnergy"
          />
        );
        break;
      case TYPE_SETPOINT:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_SETPOINT_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_SETPOINT_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.stroke = active
            ? colors.ACTION_BUTTON_ICON_SETPOINT_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        } else {
          styleImage.stroke = colors.ACTION_BUTTON_CONSTRAST_TEXT_DISABLE_COLOR;
        }
        SetPoint = setpoint === 1 ? SetPointS1 : SetPointS2;
        imageSVG = (
          <SetPoint
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="setpoint"
          />
        );
        break;
      case TYPE_TURN_ON_OFF:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <TurnOnOff
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="turnOnOff"
          />
        );
        break;
      case TYPE_GLASS_HEATER:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_GLASS_HEATER_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_GLASS_HEATER_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <GlassHeater
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="glassHeater"
          />
        );
        break;
      case TYPE_KNIFE_WIPER:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_KNIFE_WIPER_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_KNIFE_WIPER_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <KnifeWiper
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="knifeWiper"
          />
        );
        break;
      case TYPE_DOOR_HEATER:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_DOOR_HEATER_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_DOOR_HEATER_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <DoorHeater
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="doorHeater"
          />
        );
        break;
      case TYPE_SUPERFROST:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_SUPERFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_SUPERFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }

        imageSVG = (
          <SuperFrost
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="superFrost"
          />
        );
        break;
      case TYPE_HUMIDITY:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_HUMIDITY_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_HUMIDITY_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <Humidity
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="humidity"
          />
        );
        break;
      case TYPE_FLASHFREEZE:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <Flashfreeze
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="flashfreeze"
          />
        );
        break;
      case TYPE_FLASHCOOL:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_DEFROST_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        styleImage.width = '30%';
        styleImage.paddingTop = '10%';
        imageSVG = (
          <Flashcool
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="flashcool"
          />
        );
        break;
      case TYPE_SETPOINT_P1:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <SetPointP1
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="setPointP1"
          />
        );
        break;
      case TYPE_SETPOINT_P2:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <SetPointP2
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="setPointP2"
          />
        );
        break;
      case TYPE_SETPOINT_T:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <SetPointT
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="setPointT"
          />
        );
        break;
      case TYPE_SETPOINT_H:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <SetPointH
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="setPointH"
          />
        );
        break;
      case TYPE_DIRECT:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <Direct
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="direct"
          />
        );
        break;
      case TYPE_CYCLE:
        if (!disable) {
          styleBox.color = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
          styleImage.fill = active
            ? colors.ACTION_BUTTON_ICON_TURN_ON_OFF_ACTIVE_COLOR
            : colors.ACTION_BUTTON_CONSTRAST_TEXT_INACTIVE_COLOR;
        }
        imageSVG = (
          <Cycle
            className={`${classNameImage.join(' ')}`}
            style={styleImage}
            id="cycle"
          />
        );
        break;
      default:
    }
    if (label) {
      switch (size) {
        case SIZE_BIG:
          label =
            label.length > LABEL_MAX_LENGHT_SIZE_BIG
              ? `${label.substr(0, LABEL_MAX_LENGHT_SIZE_BIG)}...`
              : label;
          break;
        case SIZE_SMALL:
          label =
            label.length > LABEL_MAX_LENGHT_SIZE_SMALL
              ? `${label.substr(0, LABEL_MAX_LENGHT_SIZE_SMALL)}...`
              : label;
          break;
        default:
          label =
            label.length > LABEL_MAX_LENGHT_SIZE_MEDIUM
              ? `${label.substr(0, LABEL_MAX_LENGHT_SIZE_MEDIUM)}...`
              : label;
      }
    }

    return (
      <Status
        disable={disable}
        svgImage={imageSVG}
        size={size}
        stylesBox={styleBox}
        tooltip={tooltip}
        onClick={!disable ? onClick : null}
        label={label ? label.toUpperCase() : null}
        toggleHover={this.toggleHover}
        color={active ? styleImage.fill : styleBox.backgroundColor}
        loading={loading}
      />
    );
  }
}

ActionButton.propTypes = {
  active: PropTypes.bool.isRequired,
  disable: PropTypes.bool,
  tooltip: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string,
  type: PropTypes.string.isRequired,
  mode: PropTypes.string,
  setpoint: PropTypes.number,
};

ActionButton.defaultProps = {
  tooltip: null,
  label: null,
  onClick: null,
  size: SIZE_MEDIUM,
  mode: null,
  disable: false,
  setpoint: 1,
};
